<template>
  <v-dialog
    v-model="dialog"
    scrollable
    :overlay="false"
    max-width="700px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        outlined
        dense
        :rules="[v => !!v || 'To Account is required']"
        append-icon="mdi-account-convert"
        :value="value"
        readonly
        v-on="on"
        name="name"
        :label="'To Account: ' + account"
        id="id"
      ></v-text-field>
    </template>
    <v-card>
      <v-card-title primary-title>
        Select to Account / Client
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="clients"
          class="elevation-1"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat color="">
              <v-spacer></v-spacer>
              <div>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-cloud-search-outline"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </div>
            </v-toolbar>
          </template>

          <template v-slot:[`item.select`]="{ item }">
            <v-btn
              text
              small
              @click.native="() => onSelect(item)"
              color="primary"
            >
              select
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: [String],
    account: [String, Number],
    current: [String, Number],
  },
  data() {
    return {
      search: "",
      dialog: false,
      headers: [
        {
          text: "Full Name",
          align: "left",
          value: "FullName",
        },
        { text: "Phone", value: "Cusphone" },
        { text: "Account", value: "AccountNumber" },
        { text: "select", value: "select" },
      ],
    };
  },
  computed: {
    ...mapGetters(["CustomersList"]),
    clients() {
      return this.CustomersList.filter(
        ({ AccountNumber }) => AccountNumber != this.current
      );
    },
  },
  methods: {
    onSelect({ FullName, AccountNumber }) {
      this.$emit("selected", {
        FullName,
        AccountNumber /*  FirstName: firstName  */,
      });
      this.dialog = false;
      //   console.log(FirstName);
    },
  },
};
</script>
